import styled from 'styled-components';

export const StyledA = styled.a`
  color: ${(p) => p.isSubtle && p.theme.alias.subtle};
  position: relative;

  &::before {
    content: '';
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    position: absolute;
    background-color: ${(p) => p.theme.colors.slate[8]};
  }

  &:hover::before {
    height: 2px;
    bottom: -1px;
  }

  &:focus-visible {
    box-shadow: ${(p) => p.theme.shadows.focusInner};
  }
`;

export const StyledAButton = styled(StyledA).attrs({
  as: 'button',
})`
  padding: 0;
`;
